import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/velanapp/public_html/vapps_v2/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/home/velanapp/public_html/vapps_v2/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/home/velanapp/public_html/vapps_v2/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/velanapp/public_html/vapps_v2/src/components/shared/BlogSectionClient.jsx");
;
import(/* webpackMode: "eager" */ "/home/velanapp/public_html/vapps_v2/src/components/shared/FaqSection.jsx");
;
import(/* webpackMode: "eager" */ "/home/velanapp/public_html/vapps_v2/src/components/shared/HireSection.jsx");
;
import(/* webpackMode: "eager" */ "/home/velanapp/public_html/vapps_v2/src/components/shared/PageBanner.jsx");
;
import(/* webpackMode: "eager" */ "/home/velanapp/public_html/vapps_v2/src/components/shared/services/AboutServices.jsx");
;
import(/* webpackMode: "eager" */ "/home/velanapp/public_html/vapps_v2/src/components/shared/services/ContentSection.jsx");
;
import(/* webpackMode: "eager" */ "/home/velanapp/public_html/vapps_v2/src/components/shared/services/CostServices.jsx");
;
import(/* webpackMode: "eager" */ "/home/velanapp/public_html/vapps_v2/src/components/shared/services/IndustriesService.jsx");
;
import(/* webpackMode: "eager" */ "/home/velanapp/public_html/vapps_v2/src/components/shared/services/PortfolioService.jsx");
;
import(/* webpackMode: "eager" */ "/home/velanapp/public_html/vapps_v2/src/components/shared/services/ProcessSteps.jsx");
;
import(/* webpackMode: "eager" */ "/home/velanapp/public_html/vapps_v2/src/components/shared/services/ServicesSection.jsx");
;
import(/* webpackMode: "eager" */ "/home/velanapp/public_html/vapps_v2/src/components/shared/services/TechnologiesServices.jsx");
;
import(/* webpackMode: "eager" */ "/home/velanapp/public_html/vapps_v2/src/components/shared/services/WhyChooseServices.jsx");
;
import(/* webpackMode: "eager" */ "/home/velanapp/public_html/vapps_v2/src/components/shared/TestimonialsSection.jsx");
